export default __webpack_public_path__ + "static/media/colour-logo.266f95be.svg";